// Probably this enum should be used everywhere instead of hardcoded path strings.

export enum AppPath {
	AccountCreated = "account-created",
	ActivateUser = "activate",
	Advertisers = "advertisers",
	ChooseAdvertiser = "chooseadvertiser",
	ForgotPassword = "forgot-password",
	Login = "login",
	Order = "order",
	OrderLine = "orderline",
	OrderServices = "order-services",
	Profile = "profile",
	MyAds = "myads"
}
